/* import __COLOCATED_TEMPLATE__ from './prism-uploaded-file.hbs'; */
import Component from '@ember/component';

/**
 * This component displays an uploaded file object
 *
 * @class PrismUploadedFile
 */
export default Component.extend({
  tagName: '',
  /**
   * The uploaded file object.
   *
   * The object must have a property named `fileName`. Optionally the object may
   * have boolena properties named `error` and `loading`. If either are set to
   * true this file will render a loading or errored uploaded file.
   *
   *
   * @argument fileObject
   * @type {Object}
   */
  fileObject: null,
  /**
   * Action called when the file should be deleted
   *
   * @argument deleteFileAction
   * @type {Action}
   */
  deleteFile(_fileObject) {},
  /**
   * Text shown on the file removal button
   *
   * @argument removePromptText
   * @type {String}
   */
  removePromptText: null,
  /**
   * @argument textClass
   * @type {String}
   */
  textClass: null,
  /**
   * @argument useRounded
   * @type {Boolean}
   */
  useRounded: false
});